import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { CONTACT, FERAL } from "../mock/mock";

export default function Social() {
  return (
    <section className="bg-forge-off py-16 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-serif text-3xl text-forge-navy">Follow Our Journey</h2>
        <hr className="forge-divider" />
        <p className="text-forge-navy/70 mb-8">Stay connected for updates and guest stories</p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer"
             className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-black/10 text-forge-navy hover:border-[var(--forge-gold)] transition-colors">
            <Instagram size={18} /> Instagram
          </a>
          <a href={CONTACT.facebook} target="_blank" rel="noreferrer"
             className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-black/10 text-forge-navy hover:border-[var(--forge-gold)] transition-colors">
            <Facebook size={18} /> Facebook
          </a>
        </div>

        {/* Brought to you by Feral */}
        <div className="mt-14 pt-10 border-t border-black/10">
          <a href={FERAL.url} target="_blank" rel="noreferrer"
             className="inline-flex items-center gap-4 group">
            <img src={FERAL.logo} alt="Feral" className="h-14 w-14 object-contain transition-transform duration-300 group-hover:scale-105" />
            <span className="font-serif text-xl text-forge-navy group-hover:text-[var(--forge-gold-dark)] transition-colors">
              Forge Stays is brought to you by Feral
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
